export default __webpack_public_path__ + "static/media/logo-atlas.910011b0.svg";